import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import { convertImageUrl } from '../utils/convertImageUrl';

function PromoSection() {
  const [promo, setPromo] = useState(null);
  const [pdfAvailable, setPdfAvailable] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(doc(db, 'schedule', 'promo'), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setPromo(data);
        // Check if PDF file actually exists before trying to embed it
        if (data.flyerType === 'pdf' && data.pdfUrl) {
          fetch(data.pdfUrl, { method: 'HEAD' })
            .then(res => {
              setPdfAvailable(res.ok && res.headers.get('content-type')?.includes('pdf'));
            })
            .catch(() => setPdfAvailable(false));
        }
      } else {
        setPromo(null);
      }
    }, (err) => {
      console.error('Error listening to promo:', err);
    });
    return () => unsubscribe();
  }, []);

  if (!promo || !promo.enabled || !promo.showSection) return null;

  return (
    <section className="promo-section section-padding">
      <div className="container">
        <div className="promo-section-stacked">
          <div className="promo-flyer-wrap">
            {promo.flyerType === 'pdf' && pdfAvailable ? (
              <iframe
                src={`${promo.pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
                title={promo.title}
                className="promo-pdf-embed"
              />
            ) : promo.imageUrl ? (
              <img src={convertImageUrl(promo.imageUrl)} alt={promo.title} className="promo-flyer-img" />
            ) : null}
            <div className="promo-flyer-overlay">
              <a href="tel:+15704217680" className="btn promo-overlay-btn">
                Call Us Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PromoSection;
